// @flow
import { createCookie, getCookie, removeCookie } from './cookie';

let supported = true;
const STORAGE_KEY = 'rover_storage_fallback';

// Test all features of localStorage to determine browser compatibility.
// If incompatible, fallback to cookie based-storage.
try {
  const key = `rover_storage_test_${Math.round(Math.random() * 1e7)}`;
  window.localStorage.setItem(key, 'test');
  window.localStorage.removeItem(key);
} catch (e) {
  supported = false;
}

type Storage = {|
  setItem: (key: string, value: any) => any,
  getItem: (key: string) => any,
  removeItem: (key: string) => void,
  clear: () => void,
|};

const createStorage = (id: string, expirationDays: number = 0): Storage => ({
  setItem(key, value) {
    const data = JSON.parse(getCookie(id) || '{}');
    data[key] = value;
    createCookie(id, JSON.stringify(data), expirationDays);
    return data[key];
  },
  getItem(key) {
    const data = JSON.parse(getCookie(id) || '{}');
    return data[key];
  },
  removeItem(key) {
    const data = JSON.parse(getCookie(id) || '{}');
    delete data[key];
    createCookie(id, JSON.stringify(data), expirationDays);
    return undefined;
  },
  clear() {
    removeCookie(id);
  },
});

export const localStorage: Storage = supported
  ? window.localStorage
  : createStorage(`localStorage_${STORAGE_KEY}`, 365);
export const sessionStorage: Storage = supported
  ? window.sessionStorage
  : createStorage(`sessionStorage_${STORAGE_KEY}`, 0);



// WEBPACK FOOTER //
// ../utilities/storage.js